import { CSSProperties } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

interface Props {
  inverted?: boolean;
  content?: string;
  datas?: string;
  className?: string;
  marginTop?: string;
  style?: CSSProperties;
}

interface IThreeDotLoaderProps {
  style?: CSSProperties;
  className?: string;
}

export default function LoadingComponent({
  className,
  inverted = true,
  content = 'Loading...',
  marginTop,
}: Props) {
  return (
    <Dimmer
      active={true}
      inverted={inverted}
      style={{ marginTop: marginTop || '20px' }}
    >
      <Loader className={className} content={content} />
    </Dimmer>
  );
}
// eslint-disable-next-line
export function LoadingComponent2({
  datas,
  inverted = true,
  content = 'Asset Creating...',
}: Props) {
  return (
    <Dimmer active={true} inverted={inverted} style={{ marginTop: '20px' }}>
      <Loader content={`${content}${datas}`} />
    </Dimmer>
  );
}
export function LoadingComponent3({
  className,
  inverted = true,
  content = 'Loading...',
  marginTop,
}: Props) {
  return (
    <Dimmer
      active={true}
      inverted={inverted}
      style={{
        marginTop: marginTop || '20px',
        width: '50%',
        height: '10px',
      }}
    >
      <Loader className={className} content={content} />
    </Dimmer>
  );
}

export function ThreeDotLoader(props: IThreeDotLoaderProps) {
  const { style, className } = props;

  return (
    <div style={style} className={`${className || ''}threeDotLoader`}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
